// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner-1mUUA"};